import { render, staticRenderFns } from "./ProjectShow.vue?vue&type=template&id=17894a98&"
import script from "./ProjectShow.vue?vue&type=script&lang=js&"
export * from "./ProjectShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports